import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { Typography } from '@lacedltd/laced-components'

export const ProductActionsWrapper = styled.div({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  backgroundColor: tokens.color.yeezy.p,
  borderTop: `${tokens.borderWidth.s} solid ${tokens.color.airJordan[400]}`,
  padding: `${tokens.spacing[5]} ${tokens.spacing[6]}`,
  zIndex: tokens.zIndex.above
})

export const ProductActionsTextWrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between'
})

export const ProductActionsText = styled(Typography.Text)({
  margin: 0,

  '&:first-of-type': {
    color: tokens.color.airJordan.p
  }
})

export const ProductActionsTitle = styled(Typography.Heading)({
  width: '100%',
  marginBottom: tokens.spacing[3]
})

export const Divider = styled.hr({
  width: '100%',
  height: tokens.borderWidth.xs,
  color: tokens.color.airJordan[200],
  margin: `${tokens.spacing[5]} 0`
})
